/* eslint-disable max-len */
import HeroMob from '../assets/rebrand/home/hero/hero-mobile.png';
import HeroDesktop from '../assets/rebrand/home/hero/hero-desk.png';
import GradientMobile from '../assets/rebrand/home/clinics/bg-gradient-mobile.png';
import GradientDesktop from '../assets/rebrand/home/clinics/bg-gradient-desktop.png';
import Phone from '../assets/rebrand/home/clinics/phone.png';
import ImageCoverage01 from '../assets/rebrand/home/coverages/coverage-01.png';
import ImageCoverage02 from '../assets/rebrand/home/coverages/coverage-02.png';
import BenefitDigitalKO from '../assets/rebrand/home/benefits/benefit_digitalKO.png';
import BenefitDigitalKOMobile from '../assets/rebrand/home/benefits/benefit_digitalKO_mobile.png';
import BenefitDigitalKOModal from '../assets/rebrand/home/benefits/modal/modal_benefit_digitalKO.png';
import BenefitDigitalKOModalMobile from '../assets/rebrand/home/benefits/modal/modal_benefit_digitalKO_mobile.png';
import BenefitGMO from '../assets/rebrand/home/benefits/benefit_GMO.png';
import BenefitGMOMobile from '../assets/rebrand/home/benefits/benefit_GMO_mobile.png';
import BenefitGMOModal from '../assets/rebrand/home/benefits/modal/modal_benefit_GMO.png';
import BenefitGMOModalMobile from '../assets/rebrand/home/benefits/modal/modal_benefit_GMO_mobile.png';
import BenefitNutrition from '../assets/rebrand/home/benefits/benefit_nutrition.png';
import BenefitNutritionMobile from '../assets/rebrand/home/benefits/benefit_nutrition_mobile.png';
import BenefitNutritionModal from '../assets/rebrand/home/benefits/modal/modal_benefit_nutrition.png';
import BenefitNutritionModalMobile from '../assets/rebrand/home/benefits/modal/modal_benefit_nutrition_mobile.png';
import BenefitToqueX from '../assets/rebrand/home/benefits/benefit_toqueX.png';
import BenefitToqueXMobile from '../assets/rebrand/home/benefits/benefit_toqueX_mobile.png';
import BenefitToqueXModal from '../assets/rebrand/home/benefits/modal/modal_benefit_toqueX.png';
import BenefitToqueXModalMobile from '../assets/rebrand/home/benefits/modal/modal_benefit_toqueX_mobile.png';
import BannerMobile from '../assets/rebrand/home/banner-detail/banner-mobile.png';
import BannerDesktop from '../assets/rebrand/home/banner-detail/banner-desktop.png';
import IconWhatsapp from '../assets/rebrand/home/gl-whatsapp-solid.svg';
import heroCyberMob from '../assets/home/hero/flex-hero-mobile-cyber.png';
import heroCyberMobWebp from '../assets/home/hero/flex-hero-mobile-cyber.webp';
import heroCyberDesktop from '../assets/home/hero/flex-hero-desktop-cyber.png';
import heroCyberDesktopWebp from '../assets/home/hero/flex-hero-desktop-cyber.webp';

export const rbrModalCyber = {
  srcImgCyber: 'https://imagescdn.rimac.com/bltb8ad0bee8dde6050/654aadfe7cdbb0040a13dc26/logo-cyber-rimac.svg',
  formatTillDate: '11/13/2023',
  text: '¡No dejes pasar nuestras promos!',
  textMobile: '¡No dejes pasar nuestras promos!',
  resetEveryDay: false,
};

export const rbrHeroModel = {
  tag: '100% online',
  title: 'Cotiza tu Seguro de Salud Flexible',
  titleCyber: '¡Asegúrate en el Cyber desde S/5.30 al día!',
  description: 'Ingresa tus datos y elige tu plan de salud ideal.',
  descriptionCyber: 'Es tu momento, deja tus datos y aprovecha las ofertas exclusivas.',
  heroMob: HeroMob,
  heroDesktop: HeroDesktop,
  heroCyberMob,
  heroCyberMobWebp,
  heroCyberDesktop,
  heroCyberDesktopWebp,
};

export const tobiWhatsappModel = {
  active: true,
  activeMobile: true,
  label: 'Compra por WhatsApp',
  iconSrc: IconWhatsapp,
  link: 'https://wa.link/wsyakg',
};

export const rbrPlansFlexibleModel = {
  title: 'Nuestros planes de <span>Salud Flexible</span>',
  subTitle: 'Todos cuentan con <b>centro médico virtual gratis.</b>',
  plans: [
    {
      id: 0,
      name: 'Plan Básico',
      price: 182,
      dailyPrice: '6.07',
      currency: 'S/',
      period: 'mensual',
      minPeriod: 'diarios',
      isRecommend: false,
      coverages: [
        {
          id: 1,
          icon: 'RideGlMedicalAttentionSolid',
          description: 'Médico a domicilio',
        },
        {
          id: 2,
          icon: 'RideGlHospitalSolid',
          description: 'Atención en clínicas',
        },
        {
          id: 3,
          icon: 'RideGlAmbulanceSolid',
          description: 'Emergencias y ambulancias',
        },
      ],
    },
    {
      id: 1,
      name: 'Plan Estándar',
      price: 217,
      dailyPrice: '7.23',
      currency: 'S/',
      period: 'mensual',
      minPeriod: 'diarios',
      isRecommend: false,
      coverages: [
        {
          id: 1,
          icon: 'RideGlMedicalAttentionSolid',
          description: 'Médico a domicilio',
        },
        {
          id: 2,
          icon: 'RideGlHospitalSolid',
          description: 'Atención en clínicas',
        },
        {
          id: 3,
          icon: 'RideGlAmbulanceSolid',
          description: 'Emergencias y ambulancias',
        },
        {
          id: 4,
          icon: 'RideGlHospitalizationSolid',
          description: 'Hospitalización y maternidad',
        },
      ],
    },
    {
      id: 2,
      name: 'Plan Completo',
      price: 227,
      dailyPrice: '7.57',
      currency: 'S/',
      period: 'mensual',
      minPeriod: 'diarios',
      isRecommend: true,
      coverages: [
        {
          id: 1,
          icon: 'RideGlMedicalAttentionSolid',
          description: 'Médico a domicilio',
        },
        {
          id: 2,
          icon: 'RideGlHospitalSolid',
          description: 'Atención en clínicas',
        },
        {
          id: 3,
          icon: 'RideGlAmbulanceSolid',
          description: 'Emergencias y ambulancias',
        },
        {
          id: 4,
          icon: 'RideGlHospitalizationSolid',
          description: 'Hospitalización y maternidad',
        },
        {
          id: 5,
          icon: 'RideGlDentistSolid',
          description: 'Odontología y oftalmología',
        },
      ],
    },
    {
      id: 3,
      name: 'Plan Plus',
      price: 237,
      dailyPrice: '7.90',
      currency: 'S/',
      period: 'mensual',
      minPeriod: 'diarios',
      isRecommend: false,
      coverages: [
        {
          id: 1,
          icon: 'RideGlMedicalAttentionSolid',
          description: 'Médico a domicilio',
        },
        {
          id: 2,
          icon: 'RideGlHospitalSolid',
          description: 'Atención en clínicas',
        },
        {
          id: 3,
          icon: 'RideGlAmbulanceSolid',
          description: 'Emergencias y ambulancias',
        },
        {
          id: 4,
          icon: 'RideGlHospitalizationSolid',
          description: 'Hospitalización y maternidad',
        },
        {
          id: 5,
          icon: 'RideGlDentistSolid',
          description: 'Odontología y oftalmología',
        },
        {
          id: 6,
          icon: 'RideGlHealthSolid',
          description: 'Chequeo preventivo anual sin costo',
        },
      ],
    },
  ],
};

export const rbrClinicsModel = {
  title: '<span>+200 clínicas</span> a nivel nacional',
  description: 'Conoce la red de clínicas <b>más completa</b> con Salud Flexible',
  button: 'Ver clínicas afiliadas',
  imageGradientMob: GradientMobile,
  imageGradientDesk: GradientDesktop,
  imagePhone: Phone,
  clinics: [
    '<p>Clínica <span>Good Hope</span></p>',
    '<p>Clínica <span>Javier Prado</span></p>',
    '<p>Clínica <span>Bellavista</span></p>',
    '<p>Clínica <span>Limatambo</span></p>',
    '<p>Clínica Corazón <span>De Jesús</span></p>',
    '<p>Clínica Maison <span>De Sante Del Sur</span></p>',
    '<p>Clínica <span>Versalles</span></p>',
    '<p>Clínica San Pedro <span>De Huacho</span></p>',
    '<p>Clínica Jesús <span>Del Norte</span></p>',
    '<p>Integramedica</p>',
    '<p>Clínica <span>Internacional</span></p>',
    '<p>Clínica <span>Montefiori</span></p>',
    '<p>Clínica <span>Megasalud Universal</span></p>',
    '<p>Clínica <span>Aviva</span></p>',
    '<p>Medicis</p>',
    '<p>Medavan</p>',
    '<p>Centro Medico <span>Suiza Lab</span></p>',
    '<p>Clínica Centenario <span>Peruano Japonesa</span></p>',
    '<p>Clínica <span>Stella Maris</span></p>',
    '<p>Clínica de <span>Especialidades Médicas</span></p>',
    '<p>Clínica Padre <span>Luis Tezza</span></p>',
    '<p>Clínica <span>Vesalio</span></p>',
    '<p>Centro Médico <span>Medex</span></p>',
    '<p>Clínica San Juan <span>Bautista</span></p>',
    '<p>Clínica <span>San Gabriel</span></p>',
    '<p>Clínica <span>Providencia</span></p>',
    '<p>Clínica Santa <span>Martha del Sur</span></p>',
    '<p>Clínica <span>Cayetano Heredia</span></p>',
    '<p>Centros Médicos <span>Jockey Salud</span></p>',
    '<p>Clínica <span>San Bernardo</span></p>',
  ],
};

export const rbrCoverageModel = {
  title: 'Coberturas <span>exclusivas para ti</span>',
  description: 'Ten en cuenta que las coberturas de tu seguro de salud pueden variar según el plan que elijas.',
  image01: ImageCoverage01,
  image02: ImageCoverage02,
  coverages: [
    {
      id: 1,
      title: 'Cobertura al 100%',
      description: 'En emergencias accidentales y ambulancias.',
      icon: 'RideIcAmbulanceLight',
    },
    {
      id: 2,
      title: 'Coberturas al 70%',
      description: 'En medicinas y exámenes derivados de clínicas.',
      icon: 'RideIcMedicineLight',
    },
    {
      id: 3,
      title: 'Chequeo preventivo',
      description: 'Agéndalo una vez al año sin costo.',
      icon: 'RideIcCompleteHealthLight',
    },
    {
      id: 4,
      title: 'Médico a domicilio',
      description: 'Atención en casa a S/45 en medicina general o pediatría y medicamentos incluidos.',
      icon: 'RideIcLiveClassLight',
    },
  ],
};

export const rbrBenefitsModel = {
  title: 'Por ser cliente RIMAC',
  cards: [
    {
      img: BenefitDigitalKO,
      imgMobile: BenefitDigitalKOMobile,
      title: 'Hasta 40% en planes digitales KO',
      benefits: [
        {
          icon: 'RideGlStarSolid',
          text: 'Uso ilimitado',
        },
        {
          icon: 'RideGlPhoneSolid',
          text: '100% Digital',
        },
      ],
      cta: 'Ver detalle',
      modal: {
        title: 'Hasta 40% en planes digitales KO',
        img: BenefitDigitalKOModal,
        imgMobile: BenefitDigitalKOModalMobile,
        description: ['Accede al 40% de descuento en los planes digitales de KO para que puedas entrenar cardio, fuerza y yoga. Disponible 100% digital.'],
      },
    },
    {
      img: BenefitGMO,
      imgMobile: BenefitGMOMobile,
      title: 'Hasta 30% en lunas en GMO',
      benefits: [
        {
          icon: 'RideGlStarSolid',
          text: 'Uso ilimitado',
        },
        {
          icon: 'RideGlPinSolid',
          text: 'Lima y Provincias',
        },
      ],
      cta: 'Ver detalle',
      modal: {
        title: 'Hasta 30% en lunas en GMO',
        img: BenefitGMOModal,
        imgMobile: BenefitGMOModalMobile,
        description: ['Obtén el 30% de descuento en lunas por la compra de tus monturas para destacar tu estilo. Válido para Lima y provincias.'],
      },
    },
    {
      img: BenefitNutrition,
      imgMobile: BenefitNutritionMobile,
      title: 'Hasta 15% en la web de Lab Nutrition',
      benefits: [
        {
          icon: 'RideGlStarSolid',
          text: 'Uso ilimitado',
        },
        {
          icon: 'RideGlPinSolid',
          text: 'Lima',
        },
      ],
      cta: 'Ver detalle',
      modal: {
        title: 'Hasta 15% en la web de Lab Nutrition',
        img: BenefitNutritionModal,
        imgMobile: BenefitNutritionModalMobile,
        description: ['Aprovecha el 15% de dscto. en las líneas Solgar y Lab Nutrition para compras por la web para tus objetivos de salud. Válido para Lima.'],
      },
    },
    {
      img: BenefitToqueX,
      imgMobile: BenefitToqueXMobile,
      title: 'Hasta 15% dscto en Toque X',
      benefits: [
        {
          icon: 'RideGlStarSolid',
          text: '4 veces por semestre',
        },
        {
          icon: 'RideGlPinSolid',
          text: 'Lima y Provincias',
        },
      ],
      cta: 'Ver detalle',
      modal: {
        title: 'Hasta 15% dscto en Toque X',
        img: BenefitToqueXModal,
        imgMobile: BenefitToqueXModalMobile,
        description: ['Engríete aprovechando el 15% de dscto. en alisados y tratamientos capilares.'],
      },
    },
  ],
};

export const rbrBannerDetailModel = {
  title: '¿Necesitas más detalle sobre <span>Salud Flexible?</span>',
  description: 'Descubre lo que te ofrece cada plan de este seguro de salud flexible y <b>compra 100% online.</b>',
  button: 'Ir a cotizar',
  imageMobile: BannerMobile,
  imageDesktop: BannerDesktop,
};

export const rbrQuestionModel = {
  title: '¿Tienes dudas? <span>¡Las resolvemos!</span>',
  questions: {
    'Sobre el producto': [
      {
        question: '¿Qué es el seguro Salud Flexible?',
        answer:
          'Es un seguro con el que puedes elegir el plan que más se acomode a tus necesidades y las de tu familia. Puedes atenderte desde la comodidad de tu hogar con el Plan en Casa o en más de nuestras 200 clínicas a nivel nacional con el seguro en Casa y Clínicas. También puedes armarlo desde cero y personalizar tus coberturas.',
        icon: 'RideGlCoverageSolid',
      },
      {
        question: '¿Dónde puedo atenderme?',
        answer:
          'Si tu plan es Seguro en casa y clínica, puedes atenderte en más de 200 clínicas a nivel nacional pagando S/45 por consulta. Asimismo, tus medicamentos y exámenes derivados de la consulta estarán cubiertos en un 70%. Si elegiste el plan Seguro en casa, tus atenciones siempre serán desde la comodidad de tu hogar. Puedes acceder a un médico a domicilio pagando S/45 por consulta.',
        icon: 'RideGlHospitalSolid',
      },
      {
        question: '¿Cuánto tiempo debo esperar para hacer uso de mi seguro?',
        answer:
          'Te protegemos desde el primer día a través de la cobertura de videoconsulta y orientación telefónica. Estos beneficios están incluidos en nuestros cuatro planes. Ten en cuenta que el periodo de carencia para nuestros planes es de 30 días y el periodo de espera para usar las coberturas varía porque depende cuál sea esta.',
        icon: 'RideGlClockSolid',
      },
    ],
    'Más sobre salud': [
      {
        question: '¿Qué es un Seguro de Salud?',
        answer:
          'Es una póliza de pago mensual que cubre tus gastos de atención médica como consultas, hospitalizaciones, emergencias médicas, exámenes médicos, medicinas y más.<br/><br/>Sus principales beneficios son:<br/><br/><ul><li>Trato personalizado.</li><li>Evitas los tiempos de espera interminables.</li><li>Libre elección de médicos especializados.Por ejemplo, si por accidente te doblas el tobillo puedes elegir atenderte de inmediato en nuestras más de 200 clínicas afiliadas, sin esperar horas de horas por una atención.</li></ul>',
        icon: 'RideGlInsuranceSolid',
      },
      {
        question: '¿Qué es un deducible o copago en seguros de salud?',
        answer:
          'Es el monto fijo mínimo que debes pagar cada vez que recibas una atención ambulatoria u hospitalaria, por ejemplo, cuando vas a un centro médico, antes de recibir atención tienes que hacer un pago por la consulta; este monto es tu deducible o copago, que varía según tu tipo de seguro y clínica que hayas elegido.<br/><br/>En tu póliza encontrarás todo lo referente a tu deducible o copago, incluso los casos en los que no es necesario pagarlo.',
        icon: 'RideGlBillSolid',
      },
      {
        question: '¿Qué es el coaseguro en un seguro de salud?',
        answer:
          'Es el porcentaje del gasto que debes pagar por procedimientos y/o medicinas que se requieran para tu atención ambulatoria u hospitalaria. El costo varía según tu plan de salud contratado.<br/><br/>Por ejemplo, si tuviste un golpe en tu rodilla y el médico te indica una resonancia magnética que cueste en total S/1,000 y en tu póliza indica que tu cobertura es al 90%, solo pagarías S/100 y te ahorrarías los S/900 restantes, ya que estos los asume tu Seguro de Salud.',
        icon: 'RideGlDocumentSolid',
      },
      {
        question: '¿Qué es el periodo de carencia?',
        answer:
          'Es el tiempo (determinado en tu póliza) que debes esperar para que se activen tus coberturas. Cualquier enfermedad diagnosticada durante este periodo no será cubierta ahora ni en futuras contrataciones ya que buscamos que todos los asegurados reciban una atención igualitaria, por ejemplo, imaginemos que NO existe el periodo de carencia y dos asegurados están interesados en la atención con el mismo doctor. Juan recién contrata su seguro y ya tenía diagnóstico previo por lo que consigue una cita primero. María tiene mucho tiempo con su seguro y recibe un diagnóstico pero debe esperar porque Juan ya tenía cita con este médico.',
        icon: 'RideGlCalendarSolid',
      },
      {
        question: '¿Qué es tiempo de espera?',
        answer:
          'Es el tiempo extra al periodo de carencia que debes esperar para tratarte algunas condiciones médicas o enfermedades detalladas en tu póliza como: embarazo, trasplantes de médula, cáncer, diabetes, etc.<br/><br/>¿Hay excepciones? ¡Por supuesto! Las emergencias accidentales o los episodios agudos de enfermedades previas que requieren ¡sí o sí! atención inmediata entran en la excepción.<br/><br/>Siempre puedes revisar el detalle en el condicionado general de tu póliza.',
        icon: 'RideGlClockSolid',
      },
      {
        question: '¿Qué significa preexistencia en salud?',
        answer:
          'Es cualquier enfermedad, patología o condición de salud que sea de tu conocimiento, haya sido diagnosticada por un profesional médico y que no haya sido resuelta* antes de haber contratado tu seguro de salud o dentro del periodo de carencia. No cubrimos las preexistencias ya que, un seguro de salud es para prevenir un riesgo futuro y desconocido.<br/><br/><ul><li>Se considera una enfermedad resuelta a aquella que luego de haber recibido un tratamiento médico, no presente ninguna evidencia de la enfermedad; para lo cual se te solicitará los informes correspondientes.</li></ul>',
        icon: 'RideGlHeartSolid',
      },
    ],
  },
};

export const CYBER_CONTENT_BANNER = [
  {
    venta_digital_cintillo: {
      type: 'cyber',
      subtype: 'cyber_counter',
      text: {
        main: '¡Asegúrate hoy y participa por un Iphone 17!',
      },
      time: {
        start_date: '',
        final_date: '',
      },
      image_png: {
        image_mobile: { url: rbrModalCyber.srcImgCyber },
        image_desktop: { url: rbrModalCyber.srcImgCyber },
      },
      image_webp: {
        image_mobile: { url: rbrModalCyber.srcImgCyber },
        image_desktop: { url: rbrModalCyber.srcImgCyber },
      },
      active_counter: true,
      reset_days: 0,
      name_product: 'Cyber Days Julio',
      banner_with_redirection: {
        active_go_icon_button: false,
        url: '',
      },
    },
  },
];
